import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';
import { Features } from '../../createGridElementCalculationSetExecutionDetails';

export function findFeature(features: Features, objectId: string) {
  return features.findFeature(objectId);
}
